import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	dialogFourteen: 15,
	dialogFifteen: 16,
	dialogSixteen: 17,
	dialogSeventeen: 18,
	dialogEighteen: 19,
	win: 20
};

const stepThree = {
	move_desktop_1: {
		ui: steps.dialogEight,
		action: () => {

		}
	},
	process_buy_1: {
		ui: steps.dialogThirteen,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a13)
		}
	},
	move_desktop_2: {
		ui: steps.dialogFifteen,
		action: () => {

		}
	},
}

export const Theme6SubtopicOneActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema1], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema6.topic1.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic1.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic1.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Agua y drenaje/Información" />
					<DialogBarNew
						dialog={`¡Observa! se acerca un cliente que es perfecto para explorar el tema de agua y drenaje.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Agua y drenaje"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a02)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "move_client_1");
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<ViewPerson img={imgTema6.NetNeto_felizo} />
					<DialogBarNew
						name='Neto'
						dialog={`Hola buen día. Bienvenida ¿En qué puedo ayudar?.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ViewPerson img={imgTema6.Yolanda_tranquila} />
					<DialogBarNew
						name='Yolanda'
						dialog={`Buen día, vengo a realizar un pago de servicio.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a04)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ViewPerson img={imgTema6.Neto_tranquilo} />
					<DialogBarNew
						name='Neto'
						dialog={`¡Claro! ¿Me permite su recibo?.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ViewPerson img={imgTema6.Yolanda_reciboLuz} />
					<DialogBarNew
						name='Yolanda'
						dialog={`Si, te la comparto.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<ViewPerson img={imgTema6.Neto_tranquilo} />
					<DialogBarNew
						name='Neto'
						dialog={`¡Perfecto! Le comento, se realizará un cobro de $10 pesos extra por el servicio.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a07)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<ViewPerson img={imgTema6.Yolanda_tranquila} />
					<DialogBarNew
						name='Yolanda'
						dialog={`Sin problema, te lo agradezco.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a08)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "move_desktop_1");
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`¡Importante! No olvides revisar las comisiones de los servicios, constantemente cambian.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a09)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "move_monitor_1");
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Para iniciar el proceso de pago de servicio debes seleccionar la opción de "Servicio" y dar clic en aceptar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a10)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "texture_monitor_1");
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Verifica que la fecha que aparece en pantalla sea correcta y da clic en aceptar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a11)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "texture_monitor_2");
							setUiToShow(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`Verifica que los datos del cliente y el monto total sean correctos, y da clic en "Si".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a12)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "move_client_2");
							setUiToShow(steps.dialogTwelve);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<ViewPerson img={imgTema6.Neto_tranquilo} />
					<DialogBarNew
						name='Neto'
						dialog={`El monto a pagar es de $237 pesos. ¿Pagaría con tarjeta o efectivo?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "process_buy_1");
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirteen && (
				<>
					<ViewPerson img={imgTema6.Yolanda_dinero} />
					<DialogBarNew
						name='Yolanda'
						dialog={`Sería con efectivo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a14)
							setUiToShow(steps.dialogFourteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFourteen && (
				<>
					<ViewPerson img={imgTema6.Neto_tranquilo} />
					<DialogBarNew
						name='Neto'
						dialog={`Recibo $500 pesos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a15)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "move_desktop_2");
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFifteen && (
				<>
					<DialogBarNew
						dialog={`Recuerda que debes de marcar en la pantalla la cantidad del billete entregado por parte del Cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a16)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene, "move_client_3");
							setUiToShow(steps.dialogSixteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSixteen && (
				<>
					<ViewPerson img={imgTema6.Neto_cambio} />
					<DialogBarNew
						name='Neto'
						dialog={`Su cambio es de $263 pesos, le entrego su ticket.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a17)
							setUiToShow(steps.dialogSeventeen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeventeen && (
				<>
					<ViewPerson img={imgTema6.Yolanda_tranquila} />
					<DialogBarNew
						name='Yolanda'
						dialog={`Le agradezco mucho joven.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub01.sub1_act1_a18)
							setUiToShow(steps.dialogEighteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEighteen && (
				<>
					<ViewPerson img={imgTema6.NetNeto_felizo} />
					<DialogBarNew
						name='Neto'
						dialog={`Estoy para servirle, ¡Regrese pronto!.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema6.topic1.actScene)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}



			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Esa es la manera correcta para realizar un cobro de servicios para el agua/drenaje."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 10,
									subtema: tasksId.tema6.activities.subtema1
								})
							);
							navigator("/home6/tema6/subtema1/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}


const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}